import { isNumeric } from 'core-lib/utils/regex';
import { useEffect, useState } from 'react';
import { checkExpectedDelivery } from 'src/modules/parkplusStoreV2/services/pdp/checkExpectedDelivery';
import { formatExpectedDeliveryLabel } from 'src/modules/parkplusStoreV2/utils/formatExpectedDelivery';
import { Button } from 'ui-v2/components/Button';
import { Divider } from 'ui-v2/components/Divider';
import { Input } from 'ui-v2/components/Input';
import { Loader } from 'ui-v2/components/Loader';
import { Typography } from 'ui-v2/components/Typography';

import useParkplusStoreV2 from 'src/modules/parkplusStoreV2/hooks/useParkplusStoreV2';
import { trackCtaClickedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import Icon from 'ui-v2/components/Icon/Icon';
import s from './CheckDelivery.module.scss';

type CheckDeliveryProps = {
  pickUpPostCode?: number;
};

export const CheckDelivery = ({
  pickUpPostCode = null,
}: CheckDeliveryProps) => {
  const { deliveryAddressData } = useParkplusStoreV2();
  // state
  const [pincode, setPincode] = useState(deliveryAddressData?.pincode);
  const [status, setStatus] = useState(2);
  const [loading, setLoading] = useState(false);
  const [focus, setFocus] = useState(false);
  const [show, setShow] = useState(false);
  const [expectedDelivery, setExpectedDelivery] = useState(0);
  const [deliveryMessage, setDeliveryMessage] = useState('');

  const checkDelivery = async () => {
    setLoading(true);
    const { response, error } = await checkExpectedDelivery(
      pincode,
      pickUpPostCode
    );

    let serviceable = 2;
    if (response?.isServiceable) {
      setStatus(1);
      serviceable = 1;
      setExpectedDelivery(response?.maxExpected);
      setDeliveryMessage(response?.deliveryMessage ?? '');
    } else {
      setStatus(0);
      serviceable = 0;
      setDeliveryMessage('');
    }

    if (error) {
      setStatus(0);
      serviceable = 0;
      setDeliveryMessage('');
    }

    const payload = {
      pincode,
      serviceable,
    };

    // dispatch(updateDeliveryPincode(payload));

    setFocus(false);
    setLoading(false);
    setShow(true);
  };

  const checkDeliveryClick = () => {
    if (status !== 2 && focus === true) {
      checkDelivery();
      trackCtaClickedStoreV2('check_delivery', 'check', {
        pincode: pincode,
      });
    } else if (status !== 2 && pincode.length === 6) {
      setPincode('');
      setFocus(true);
      setShow(false);
      trackCtaClickedStoreV2('check_delivery', 'change');
    } else if (status === 2) {
      checkDelivery();
      trackCtaClickedStoreV2('check_delivery', 'check', {
        pincode: pincode,
      });
    }
  };

  const handleChange = (e) => {
    if (status !== 2) {
      setFocus(true);
      setPincode(e.target.value.trim());
      setShow(false);
    } else {
      setPincode(e.target.value);
    }
  };

  useEffect(() => {
    if (pincode) {
      checkDelivery();
    }
  }, []);

  return (
    <>
      <Divider variant="padded" />
      <div className={s.pincodeContainer}>
        <Typography
          label="Check delivery availability:"
          variant="label_3_medium"
        />
        <div className={s.input}>
          <Input
            inputType="numeric"
            maxLength={6}
            placeholder="Enter pincode here"
            onChange={(e: any) => {
              // @ts-ignore
              if (
                isNumeric(e.target.value) &&
                e.target.value.toString().length < 7
              ) {
                handleChange(e);
              }
            }}
            value={pincode}
            autoFocus={focus}
            rightIcon={
              <div className={s.button}>
                {loading ? (
                  <Loader />
                ) : (
                  <Button
                    label={
                      // eslint-disable-next-line no-nested-ternary
                      status !== 2 && !focus && pincode.length === 6
                        ? 'Change'
                        : status !== 2 && focus
                        ? 'Check'
                        : 'Check'
                    }
                    variant="link_color"
                    size="small"
                    disabled={pincode?.length !== 6}
                    onClick={() => checkDeliveryClick()}
                  />
                )}
              </div>
            }
          />
        </div>
        {status === 1 && show && (
          <div className={s.delivery_message}>
            <Icon name="TruckRegular" color="primary" width={16} height={16} />

            {/* <Typography
              label={pincode}
              variant={TypeScales.body_para_sb}
              color={Color.interaction_buttons}
            /> */}
            <Typography
              label={`Delivery to ${pincode} by`}
              variant="label_4_medium"
              color="tertiary"
            />
            <Typography
              label={formatExpectedDeliveryLabel({
                days: expectedDelivery,
                deliveryMessage,
              })}
              variant="label_4_bold"
              color="positive_dark"
            />
          </div>
        )}
        {status === 0 && show && (
          <div className={s.delivery_message}>
            <Typography
              label="We do not deliver to this location yet, change pincode"
              variant="label_4_medium"
              color="tertiary"
            />
          </div>
        )}
      </div>
      <Divider variant="padded" />
    </>
  );
};
